import type { QuizQuestion, ScentFamily } from '@/types'

export const quizQuestions: QuizQuestion[] = [
  {
    id: 'occasion',
    question: 'When do you most want to feel unforgettable?',
    options: [
      { id: 'day', label: 'During a relaxed afternoon', weights: { Citrus: 3, Fresh: 3, Floral: 1, Woody: 1, Oriental: 0, Gourmand: 0 } },
      { id: 'evening', label: 'At a dinner or date', weights: { Oriental: 3, Floral: 2, Gourmand: 2, Woody: 1, Citrus: 0, Fresh: 0 } },
      { id: 'work', label: 'In a meeting or creative flow', weights: { Fresh: 3, Woody: 2, Citrus: 2, Floral: 1, Oriental: 0, Gourmand: 0 } },
      { id: 'weekend', label: 'Escaping somewhere new', weights: { Woody: 3, Citrus: 2, Oriental: 1, Fresh: 1, Floral: 0, Gourmand: 1 } },
    ],
  },
  {
    id: 'season',
    question: 'Which season feels most like you?',
    options: [
      { id: 'spring', label: 'Spring', weights: { Floral: 3, Fresh: 2, Citrus: 2, Woody: 0, Oriental: 0, Gourmand: 0 } },
      { id: 'summer', label: 'Summer', weights: { Citrus: 3, Fresh: 3, Floral: 1, Woody: 0, Oriental: 0, Gourmand: 0 } },
      { id: 'autumn', label: 'Autumn', weights: { Oriental: 3, Woody: 2, Gourmand: 2, Floral: 1, Citrus: 0, Fresh: 0 } },
      { id: 'winter', label: 'Winter', weights: { Oriental: 3, Gourmand: 3, Woody: 2, Fresh: 0, Citrus: 0, Floral: 0 } },
    ],
  },
  {
    id: 'mood',
    question: 'Pick a word that describes your ideal vibe.',
    options: [
      { id: 'bright', label: 'Bright', weights: { Citrus: 3, Fresh: 2, Floral: 1, Woody: 0, Oriental: 0, Gourmand: 0 } },
      { id: 'warm', label: 'Warm', weights: { Oriental: 3, Gourmand: 3, Woody: 2, Floral: 0, Citrus: 0, Fresh: 0 } },
      { id: 'clean', label: 'Clean', weights: { Fresh: 3, Citrus: 2, Woody: 1, Floral: 1, Oriental: 0, Gourmand: 0 } },
      { id: 'mysterious', label: 'Mysterious', weights: { Oriental: 3, Woody: 2, Floral: 1, Gourmand: 1, Citrus: 0, Fresh: 0 } },
    ],
  },
  {
    id: 'notes',
    question: 'Which ingredient would you wear as a signature?',
    options: [
      { id: 'bergamot', label: 'Bergamot', weights: { Citrus: 3, Fresh: 1, Floral: 0, Woody: 0, Oriental: 0, Gourmand: 0 } },
      { id: 'rose', label: 'Rose', weights: { Floral: 3, Oriental: 1, Woody: 0, Citrus: 0, Fresh: 0, Gourmand: 0 } },
      { id: 'sandalwood', label: 'Sandalwood', weights: { Woody: 3, Oriental: 1, Fresh: 0, Citrus: 0, Floral: 0, Gourmand: 0 } },
      { id: 'vanilla', label: 'Vanilla', weights: { Gourmand: 3, Oriental: 2, Floral: 0, Woody: 0, Citrus: 0, Fresh: 0 } },
    ],
  },
  {
    id: 'intensity',
    question: 'How do you want your fragrance to announce itself?',
    options: [
      { id: 'intimate', label: 'Only when someone is close', weights: { Fresh: 3, Woody: 2, Floral: 1, Citrus: 1, Oriental: 0, Gourmand: 0 } },
      { id: 'noticeable', label: 'A polite, pleasant trail', weights: { Floral: 3, Citrus: 2, Woody: 1, Fresh: 1, Oriental: 0, Gourmand: 0 } },
      { id: 'bold', label: 'Bold and memorable', weights: { Oriental: 3, Gourmand: 2, Woody: 2, Floral: 1, Citrus: 0, Fresh: 0 } },
      { id: 'layered', label: 'Complex and evolving', weights: { Oriental: 2, Woody: 2, Floral: 2, Gourmand: 1, Citrus: 0, Fresh: 0 } },
    ],
  },
  {
    id: 'compliment',
    question: 'The best compliment someone could pay your scent?',
    options: [
      { id: 'elegant', label: '"You smell elegant."', weights: { Floral: 3, Woody: 2, Oriental: 1, Citrus: 0, Fresh: 0, Gourmand: 0 } },
      { id: 'delicious', label: '"I want to eat it."', weights: { Gourmand: 3, Oriental: 1, Floral: 0, Woody: 0, Citrus: 0, Fresh: 0 } },
      { id: 'fresh', label: '"You smell so clean."', weights: { Fresh: 3, Citrus: 2, Woody: 0, Floral: 0, Oriental: 0, Gourmand: 0 } },
      { id: 'sexy', label: '"That is addictive."', weights: { Oriental: 3, Woody: 2, Gourmand: 1, Floral: 1, Citrus: 0, Fresh: 0 } },
    ],
  },
]

export function scoreQuiz(
  answers: Record<string, string>,
  questions: QuizQuestion[] = quizQuestions
): Record<ScentFamily, number> {
  const scores: Record<ScentFamily, number> = {
    Citrus: 0,
    Floral: 0,
    Woody: 0,
    Oriental: 0,
    Fresh: 0,
    Gourmand: 0,
  }

  for (const question of questions) {
    const selectedId = answers[question.id]
    const option = question.options.find((o) => o.id === selectedId)
    if (!option) continue
    for (const [family, weight] of Object.entries(option.weights)) {
      scores[family as ScentFamily] += weight
    }
  }

  return scores
}
